module.exports = function() {
  return new Worker(__webpack_public_path__ + "71369368d8aacd55cea5.worker.js");
};